var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsumedFromPv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_36981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#EBFFF3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6577_36981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9155 14.2454C25.8285 14.1184 25.6855 14.0422 25.5337 14.0422H13.0984C12.9026 14.0422 12.7269 14.1676 12.6601 14.3555L9.34403 23.6676C9.29222 23.8137 9.31294 23.9761 9.40051 24.1036C9.48756 24.2306 9.63056 24.3068 9.78237 24.3068H13.9243C13.9243 24.3068 13.9264 24.3068 13.9275 24.3068C13.928 24.3068 13.9285 24.3068 13.929 24.3068H16.1554V25.0475H13.9275C13.6699 25.0475 13.4611 25.2608 13.4611 25.5237C13.4611 25.7867 13.6699 25.9999 13.9275 25.9999H19.3161C19.5736 25.9999 19.7824 25.7867 19.7824 25.5237C19.7824 25.2608 19.5736 25.0475 19.3161 25.0475H17.0881V24.3068H18.0694C18.0694 24.3068 18.0715 24.3068 18.0725 24.3068C18.073 24.3068 18.0736 24.3068 18.0741 24.3068H22.2176C22.4135 24.3068 22.5891 24.1814 22.6559 23.9936L25.972 14.6814C26.0238 14.5354 26.0031 14.3729 25.9155 14.2454ZM14.5933 23.3544L15.9119 19.6507H19.0648L17.7461 23.3544H14.5933ZM16.2513 18.6983L17.5699 14.9946H20.7228L19.4041 18.6983H16.2513ZM13.4249 14.9946H16.5777L15.2591 18.6983H12.1062L13.4249 14.9946ZM11.7668 19.6507H14.9197L13.601 23.3544H10.4482L11.7668 19.6507ZM21.8907 23.3544H18.7378L20.0565 19.6507H23.2093L21.8907 23.3544ZM23.5487 18.6983H20.3958L21.7145 14.9946H24.8673L23.5487 18.6983Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2694 8.22222C12.5269 8.22222 12.7357 8.00899 12.7357 7.74603V6.47619C12.7357 6.21323 12.5269 6 12.2694 6C12.0119 6 11.8031 6.21323 11.8031 6.47619V7.74603C11.8031 8.00899 12.0119 8.22222 12.2694 8.22222Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.71553 9.44655C8.80672 9.53968 8.9259 9.58624 9.04507 9.58624C9.16424 9.58624 9.28393 9.53968 9.3746 9.44655C9.55646 9.26084 9.55646 8.95925 9.3746 8.77301L8.49533 7.87513C8.31294 7.68941 8.01812 7.68941 7.83574 7.87513C7.65387 8.06084 7.65387 8.36243 7.83574 8.54867L8.71501 9.44655H8.71553Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.17617 12.4022C8.17617 12.1393 7.96736 11.926 7.70984 11.926H6.46632C6.20881 11.926 6 12.1393 6 12.4022C6 12.6652 6.20881 12.8784 6.46632 12.8784H7.70984C7.96736 12.8784 8.17617 12.6652 8.17617 12.4022Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.37512 15.3577C9.19325 15.172 8.89792 15.1715 8.71553 15.3577L7.83626 16.2556C7.65439 16.4413 7.65439 16.7429 7.83626 16.9292C7.92745 17.0223 8.04662 17.0689 8.16579 17.0689C8.28496 17.0689 8.40465 17.0223 8.49533 16.9292L9.3746 16.0313C9.55647 15.8456 9.55647 15.544 9.3746 15.3577H9.37512Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3627 12.4022C16.3627 12.6652 16.5715 12.8784 16.829 12.8784H18.0725C18.3301 12.8784 18.5389 12.6652 18.5389 12.4022C18.5389 12.1393 18.3301 11.926 18.0725 11.926H16.829C16.5715 11.926 16.3627 12.1393 16.3627 12.4022Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4938 9.5857C15.613 9.5857 15.7327 9.53914 15.8233 9.44602L16.7026 8.54814C16.8845 8.36242 16.8845 8.06083 16.7026 7.87459C16.5202 7.68835 16.2254 7.68888 16.043 7.87459L15.1637 8.77248C14.9819 8.95819 14.9819 9.25978 15.1637 9.44602C15.2549 9.53914 15.3741 9.5857 15.4933 9.5857H15.4938Z",
    fill: "#00AC69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2088 15.6671C11.2575 15.6835 11.3067 15.6915 11.3554 15.6915C11.5508 15.6915 11.7332 15.565 11.7979 15.365C11.8788 15.1153 11.7466 14.846 11.5021 14.7629C10.5041 14.4253 9.83367 13.4761 9.83367 12.402C9.83367 11.0306 10.9259 9.91527 12.2689 9.91527C13.6119 9.91527 14.7041 11.0306 14.7041 12.402C14.7041 12.6063 14.6798 12.8095 14.6321 13.0057C14.5699 13.2608 14.7218 13.5195 14.972 13.583C15.2218 13.6465 15.4751 13.4915 15.5373 13.2359C15.6036 12.9645 15.6373 12.6841 15.6373 12.402C15.6373 10.5057 14.1264 8.96289 12.2694 8.96289C10.4124 8.96289 8.90155 10.5057 8.90155 12.402C8.90155 13.8878 9.82901 15.1999 11.2088 15.6671Z",
    fill: "#00AC69"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_36981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6577_36981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumedFromPv);
export default __webpack_public_path__ + "static/media/consumed-from-pv.4d1b0df791f12bf5f6e50d7222c114f6.svg";
export { ForwardRef as ReactComponent };